
























import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPolicy, IPolicyStep, StepType } from 'admiral-core';

import 'vue-select/dist/vue-select.css';
import { Util } from '@/utils/Util';
import Avatar from '@/components/common/Avatar.vue';
import { mixins } from 'vue-class-component';
import { FormatMixin } from '@/mixins/FormatMixin';

@Component({
  components: { Avatar },
})
export default class PolicyTimeline extends mixins(FormatMixin) {
  @Prop({ required: true, type: Object })
  policy!: IPolicy;

  timestampStr(policyStep: IPolicyStep) {
    return Util.formatDate(policyStep.createdAt);
  }
  timestampFullStr(policyStep: IPolicyStep) {
    return Util.formatDateFull(policyStep.createdAt);
  }

  get steps() {
    return this.policy.policySteps.sort((a: IPolicyStep, b: IPolicyStep) => {
      if (new Date(a.createdAt).getTime() >= new Date(b.createdAt).getTime()) {
        return -1;
      }

      return 1;
    });
  }

  timelinePointType(policyStep: IPolicyStep) {
    switch (policyStep.type) {
      case StepType.Comment:
        return 'timeline-point-secondary';
      case StepType.Edited:
        return 'timeline-point-secondary';
      case StepType.TransitionOpen:
        return 'timeline-point-info';
      case StepType.TransitionSubmitted:
        return 'timeline-point-warning';
      case StepType.TransitionDeclined:
        return 'timeline-point-danger';
      case StepType.TransitionDeleted:
        return 'timeline-point-danger';
      case StepType.TransitionPoliced:
        return 'timeline-point-success';
    }
  }
}
